
import * as pdfjs from 'pdfjs-dist';
// @ts-ignore
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import _ from 'lodash';
import printJS from 'print-js';
import { showNotification } from '@/main/utils/notifications';

import { httpRequest } from './httpRequest';

export class PdfProvider {
	url: string;
	isStaticFile = false;
	pdf: pdfjs.PDFDocumentProxy | null = null;
	pdfBlob: Blob | null = null;
	pdfUrl: string | null = null;
	fileName: string;
	fetchPdfProvider: Function | null = null;


	constructor(url: string, fetchPdfProvider: Function | null = null, fileName: string = 'DmsTemporary') {
		this.url = url;
		this.isStaticFile = url?.startsWith('/assets/static') ?? false;
		this.fetchPdfProvider = fetchPdfProvider;
		this.fileName = fileName;
	}

	async fetch(filter: {} = {}, multipart = false) {
		try {
			pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
			if (!this.isStaticFile) {
				const resp = await ((this.fetchPdfProvider) ? this.fetchPdfProvider(filter) : httpRequest.fetchPdf(this.url, filter));
				if (!resp.data || resp.status !== 200) {
					return null;
				}
				this.pdfBlob = new Blob([resp.data], { type: 'application/pdf' });
				this.pdfUrl = URL.createObjectURL(this.pdfBlob);
			} else {
				this.pdfUrl = this.url;
			}
			if (!this.pdfUrl) throw Error('pdfUrl can`t be null');
			const { promise: pdfPromise } = pdfjs.getDocument({ url: this.pdfUrl });
			this.pdf = await pdfPromise;
			return { pdfBlob: this.pdfBlob, pdf: this.pdf };
		} catch (err) {
			showNotification({ title: err.name, message: err.message });
			return err;
		}
	}

	async pages() {
		if (!this.pdf) throw Error('pdf can`t be null');
		const promisesMapper = (value: number) => new Promise((resolve) => this.pdf && resolve(this.pdf.getPage(value + 1)));
		try {
			const promises = _.range(0, this.pdf.numPages).map(promisesMapper);
			return await Promise.all(promises);
		} catch (err) {
			showNotification({ title: err.name, message: err.message });
			return err;
		}
	}

	/**
	 * Vytiskne PDF.
	 * Callback je nefunkční: https://github.com/crabbly/Print.js/issues/495
	 * @param onPrintDialogClose callback po uzavření tiskového dialogu
	 */
	print(onPrintDialogClose?: () => void) {
		if (!this.pdfUrl) throw Error('pdfProvider: No pdfUrl present. Please call fetch method first!');
		printJS({ printable: this.pdfUrl, type: 'pdf', onPrintDialogClose });
	}

	save() {
		if (!this.pdfUrl) throw Error('pdfUrl can`t be null');
		const link = document.createElement('a');
		link.href = this.pdfUrl;
		link.download = `${this.fileName}.pdf`;
		link.click();
	}
}
